const FullScreenOn = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 6.5A2.5 2.5 0 0 1 6.5 4h1.75a.5.5 0 0 1 0 1H6.5A1.5 1.5 0 0 0 5 6.5v1.75a.5.5 0 0 1-1 0zm11.25-2a.5.5 0 0 1 .5-.5h1.75A2.5 2.5 0 0 1 20 6.5v1.75a.5.5 0 0 1-1 0V6.5A1.5 1.5 0 0 0 17.5 5h-1.75a.5.5 0 0 1-.5-.5M4.5 15.25a.5.5 0 0 1 .5.5v1.75A1.5 1.5 0 0 0 6.5 19h1.75a.5.5 0 0 1 0 1H6.5A2.5 2.5 0 0 1 4 17.5v-1.75a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v1.75a2.5 2.5 0 0 1-2.5 2.5h-1.75a.5.5 0 0 1 0-1h1.75a1.5 1.5 0 0 0 1.5-1.5v-1.75a.5.5 0 0 1 .5-.5"
      clipRule="evenodd"
    />
  </>
)
export default FullScreenOn
